document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById('callMeBackModal') && document.getElementsByClassName('call-me-back').length > 0) {
        let ebModal = document.getElementById('callMeBackModal'),
            ebBtns = document.querySelectorAll(".call-me-back"),
            ebSpans = document.querySelectorAll(".modal-close");

        ebBtns.forEach(ebBtn => {
            ebBtn.addEventListener('click', (e) => {
                e.preventDefault();
                ebModal.style.display = "block";
            });
        });

        ebSpans.forEach(ebSpan => {
            ebSpan.addEventListener('click', (e) => {
                e.preventDefault();

                ebModal.style.display = "none";
            });
        });

        document.querySelector('.btn-callback').addEventListener('click', (e) => {
            let sucessMessage = document.querySelector('.message.success');

            if (sucessMessage) {
                sucessMessage.remove();
            }
        });

        window.onclick = function(event) {
            if (event.target === ebModal) {
                ebModal.style.display = "none";
            }
        }
    }

    if (document.getElementById('saveForLaterModal') && document.getElementById('saveForLater')) {

        let ebModal = document.getElementById('saveForLaterModal'),
            ebBtn = document.getElementById("saveForLater"),
            ebSpan = document.querySelector(".modal-close");

        ebBtn.onclick = function(e) {
            e.preventDefault();
            ebModal.style.display = "block";
        }

        ebSpan.onclick = function() {
            ebModal.style.display = "none";
        }

        window.onclick = function(event) {
            if (event.target === ebModal) {
                ebModal.style.display = "none";
            }
        }

    }
});
